module.exports = __webpack_public_path__ + "dimer/static/img/14.7d74f10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/14.jpg
// module id = 6cHO
// module chunks = 0